import { supabase } from "@/infrastructure/supabase/client";
import type { PhaseRow } from "@/infrastructure/supabase/database.types";

export const phasesRepository = {
  async list(): Promise<PhaseRow[]> {
    const { data, error } = await supabase
      .from("phases")
      .select("*")
      .order("number", { ascending: true });
    if (error) throw error;
    return data ?? [];
  },

  async current(): Promise<PhaseRow | null> {
    const { data, error } = await supabase
      .from("phases")
      .select("*")
      .lte("week_of", new Date().toISOString())
      .order("week_of", { ascending: false })
      .limit(1)
      .maybeSingle();
    if (error) throw error;
    return data;
  },

  async update(
    id: string,
    patch: Partial<Omit<PhaseRow, "id" | "created_at" | "updated_at">>
  ): Promise<PhaseRow> {
    const { data, error } = await supabase
      .from("phases")
      .update(patch)
      .eq("id", id)
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },
};
